import { render, staticRenderFns } from "./ProcessTypeFilter.vue?vue&type=template&id=18fad826&scoped=true"
import script from "./ProcessTypeFilter.ts?vue&type=script&lang=ts&external"
export * from "./ProcessTypeFilter.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessTypeFilter.vue?vue&type=style&index=0&id=18fad826&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fad826",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18fad826')) {
      api.createRecord('18fad826', component.options)
    } else {
      api.reload('18fad826', component.options)
    }
    module.hot.accept("./ProcessTypeFilter.vue?vue&type=template&id=18fad826&scoped=true", function () {
      api.rerender('18fad826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Alerts/components/ProcessesTableSection/ProcessTypeFilter/ProcessTypeFilter.vue"
export default component.exports